import { Alert } from '@vkontakte/vkui';
import type { Guest, SeatingTable } from '../../types';

export type CompanionPromptState =
  | { kind: 'capacity'; guest: Guest; table: SeatingTable; filled: number }
  | { kind: 'pair-together'; guest: Guest; companion: Guest; table: SeatingTable }
  | { kind: 'pair-split'; guest: Guest; companion: Guest; table: SeatingTable }
  | {
      kind: 'companion-elsewhere';
      guest: Guest;
      companion: Guest;
      table: SeatingTable;
      companionTable: SeatingTable | null;
    }
  | { kind: 'unassign-pair'; guest: Guest; companion: Guest };

interface CompanionPromptProps {
  prompt: CompanionPromptState;
  onPrimary: () => void;
  onSecondary: () => void;
  onDismiss: () => void;
}

export default function CompanionPrompt({ prompt, onPrimary, onSecondary, onDismiss }: CompanionPromptProps) {
  let title = '';
  let description: string | undefined;
  let primary = '';
  let secondary = '';
  let primaryMode: 'default' | 'destructive' = 'default';
  let secondaryMode: 'default' | 'cancel' = 'cancel';

  switch (prompt.kind) {
    case 'capacity':
      title = `Стол заполнен (${prompt.filled}/${prompt.table.seats})`;
      description = 'Всё равно посадить?';
      primary = 'Всё равно';
      secondary = 'Отмена';
      primaryMode = 'destructive';
      break;
    case 'pair-together':
      title = `Посадить вместе с ${prompt.companion.first_name}?`;
      primary = 'Вместе';
      secondary = `Только ${prompt.guest.first_name}`;
      secondaryMode = 'default';
      break;
    case 'pair-split':
      title = 'За столом 1 свободное место';
      description = 'Пара будет разделена';
      primary = 'Всё равно';
      secondary = 'Отмена';
      primaryMode = 'destructive';
      break;
    case 'companion-elsewhere':
      title = `${prompt.companion.first_name} сидит за столом «${prompt.companionTable?.name || 'стол'}»`;
      description = 'Пересадить сюда же?';
      primary = 'Пересадить';
      secondary = 'Нет';
      secondaryMode = 'default';
      break;
    case 'unassign-pair':
      title = `Снять и ${prompt.companion.first_name}?`;
      primary = 'Обоих';
      secondary = 'Только одного';
      primaryMode = 'destructive';
      secondaryMode = 'default';
      break;
  }

  return (
    <div className="st-alert-layer">
      <Alert
        usePortal={false}
        actionsLayout="horizontal"
        actions={[
          { title: primary, mode: primaryMode, autoCloseDisabled: true, action: onPrimary },
          { title: secondary, mode: secondaryMode, autoCloseDisabled: true, action: onSecondary },
        ]}
        onClose={onDismiss}
        onClosed={onDismiss}
        title={title}
        description={description}
      />
    </div>
  );
}
